/** Mirrors the server's soft cap — the displayed score never exceeds this. */
export const TRUST_SCORE_MAX = 1000;

export const TRUST_TIERS_ORDER = [
  'newcomer',
  'rising',
  'trusted',
  'verified_campus_member',
  'campus_pro',
  'campus_legend',
] as const;
export type TrustTier = (typeof TRUST_TIERS_ORDER)[number];

/** Spec §2.1 — ordered high → low; the first tier the score reaches wins. */
export const TRUST_TIERS: { min: number; tier: TrustTier; label: string; color: string }[] = [
  { min: 950, tier: 'campus_legend', label: 'Campus Legend', color: 'var(--color-coin, #E0A41F)' },
  { min: 800, tier: 'campus_pro', label: 'Campus Pro', color: 'var(--color-ink, #141A2B)' },
  { min: 600, tier: 'verified_campus_member', label: 'Verified', color: 'var(--color-success)' },
  { min: 400, tier: 'trusted', label: 'Trusted', color: 'var(--color-info)' },
  { min: 200, tier: 'rising', label: 'Rising', color: 'var(--color-warn)' },
  { min: 0, tier: 'newcomer', label: 'Newcomer', color: 'var(--color-danger)' },
];

export const tierFor = (score: number): { tier: TrustTier; label: string; color: string } => {
  const match = TRUST_TIERS.find((entry) => score >= entry.min);
  // The min-0 newcomer tier catches any non-negative score; this literal keeps the return
  // non-undefined for the type checker (array indexing is `| undefined` under noUncheckedIndexedAccess).
  return match ?? { tier: 'newcomer', label: 'Newcomer', color: 'var(--color-danger)' };
};

export const TRUST_PILLAR_LABELS: { key: 'p1' | 'p2' | 'p3' | 'p4' | 'p5'; label: string }[] = [
  { key: 'p1', label: 'Identity & verification' },
  { key: 'p2', label: 'Transaction reliability' },
  { key: 'p3', label: 'Community reputation' },
  { key: 'p4', label: 'Community participation' },
  { key: 'p5', label: 'History & longevity' },
];
